import styles from './RowAutocomplete.module.css'
import { PlusOutlined } from '@ant-design/icons'

function RowAutocomplete({ uid, fullName, mail }) {
  const initials = fullName
    .split(' ')
    .map((name) => name.charAt(0))
    .join('')
    .toUpperCase()

  return (
    <div className={styles.row}>
      <div className={styles.avatar}>{initials}</div>

      <div className={styles.container__informations}>
        <div className={styles.fullName}>{fullName}</div>
        {/* Ne plus afficher l'UID */}
        {/* <div className={styles.login}>{uid}</div> */}
        <div className={styles.email}>{mail}</div>
      </div>
      <div className={styles.add}>
        <a className={styles.button__add}>
          <PlusOutlined />
        </a>
      </div>
    </div>
  )
}

export default RowAutocomplete
